module.exports = __webpack_public_path__ + "assets/img/404@2x.1df4ad12.png";